// extracted by mini-css-extract-plugin
module.exports = {"segmented_filters":"styles_segmented_filters__2jwVE"};